import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';

import { getCourseImage } from '../../../utils/course-utils';

const courseTypeToString = type => {
  switch (type) {
    case 1:
      return 'C#';
    case 2:
      return 'Javascript';
    case 3:
      return 'Typescript';
    case 4:
      return 'Nodejs';
    default:
      return 'Unknown course type';
  }
};

const userLevelToString = level => {
  switch (level) {
    case 1:
      return 'BEGINNER';
    case 2:
      return 'INTERMEDIATE';
    case 3:
      return 'ADVANCED';
    default:
      return 'ADVANCED';
  }
};

const UserProfileCourse = props => {
  const percent =
    props.course.webinarsCount > 0 ? Math.ceil((props.course.webinarsPassed / props.course.webinarsCount) * 100) : 0;
  return (
    <div className="user-course-container">
      <div className="is-flex align-items-center">
        <img src={getCourseImage(props.course.type)} />
        <div className="ml-10px">
          <p className="user-course-title">{courseTypeToString(props.course.type)}</p>
          <p className="user-course-title is-bold">{props.course.name}</p>
        </div>
      </div>

      <div className="is-flex align-items-center">
        <div style={{ marginRight: '100px' }}>
          <p className="user-course-info">
            {props.course.webinarsPassed}/{props.course.webinarsCount} lessons finished
          </p>
          <p className="user-course-info">LEVEL: {userLevelToString(props.course.level)}</p>
        </div>
        <CircularProgressbar
          value={percent}
          text={`${percent}%`}
          styles={{
            root: {
              width: '55px', // TODO add class name
            },
            path: {
              stroke: '#6819B8',
            },
            text: {
              // Text color
              fill: '#6819B8',
              // Text size
              fontSize: '26px',
            },
          }}
        />
      </div>
    </div>
  );
};

UserProfileCourse.propTypes = {
  course: PropTypes.shape({
    webinarsPassed: PropTypes.number.isRequired,
    webinarsCount: PropTypes.number.isRequired,
    type: PropTypes.number.isRequired,
    level: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

export default UserProfileCourse;
